import { useEffect, useState } from "react";
import { Link } from "wouter";
import { RoomScreen } from "../games/common/RoomScreen";
import { useI18n } from "../i18n";
import { openLocal } from "../lib/local-registry";
import type { LocalRoom } from "../lib/local-room";

export function LocalPage({ code }: { code: string }) {
  const { d } = useI18n();
  const [room, setRoom] = useState<LocalRoom | null | undefined>(undefined);
  useEffect(() => {
    let alive = true;
    openLocal(code).then((r) => alive && setRoom(r));
    return () => {
      alive = false;
    };
  }, [code]);
  if (room === undefined) return <div className="grid min-h-[70dvh] place-items-center text-xl font-bold text-ink-3">{d.common.loading}</div>;
  if (room === null)
    return (
      <div className="shell grid min-h-[70dvh] place-items-center text-center">
        <div>
          <p className="text-xl text-ink-2">{d.room.gone}</p>
          <Link href="/" className="btn mt-6">{d.room.toHome}</Link>
        </div>
      </div>
    );
  return <RoomScreen client={room} />;
}
